namespace HA.Core.HTML {
    //noinspection TsLint
    export class TextField extends Div {
        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            if (typeof data == "string") {
                data  = toMap({text : document.createTextNode(data)});
            }
            super.initialize(data);
            this.addClass("tf");
            this.appendChild(this.get("text"));
        }
    }
}
